<!-- pass in theme to get desired button color, size for the padding top and bottom, radius for border radius.

to get desired button width, in the file where you are using the button wrap the button component in a div and apply a width to that wrapper div eg <div classname="w-[10%]"><buttonComponent/></div>

for the button text and to create variations with and without icons the components uses slots

example of what the button component might look like in your file:

<Button 
:theme="'danger'"
:size="'large'" 
:radius="'medium'"
@handleClick="testClick"
  >
      <img src="@/assets/svg/arrow-left.svg" />
      <p class="text-white font-medium text-[16px]">Go to Dashboard</p>

    </Button>

-->

<template>
  <!-- @click="$emit('handleClick')" -->
  <button
    type="buttonType"
    class="flex items-center justify-center w-full gap-2 px-2 disabled:cursor-not-allowed"
    :class="[themeStyle, sizeStyle, RadiusStyle, buttonWidth]"
    :disabled="disabled"
    @click="handleClick"
  >
    <slot></slot>
  </button>
</template>

<script>
export default {
  props: {
    theme: {
      type: String,
      required: false,
      default: "",
    },
    size: {
      type: String,
      required: false,
      default: "",
    },
    buttonWidth: {
      type: String,
      required: false,
    },
    radius: {
      type: String,
      required: false,
      default: "small",
    },
    disabled: {
      type: Boolean,
      required: false,
    },
    buttonType: {
      type: String,
      required: false,
      default: "button",
    },

    eventName: String,
    eventCategory: String,
    eventLabel: String,
  },
  data() {
    return {
      themeStyle: "blackSolid",
      sizeStyle: "py-[10px]",
      RadiusStyle: "rounded-[50px]",
    };
  },
  mounted() {
    switch (this.size) {
      case "large":
        this.sizeStyle = "py-[20px]";
        break;
      case "medium":
        this.sizeStyle = "py-[10px]";
        break;
      case "small":
        this.sizeStyle = "py-2";
        break;
      case "extraSmall":
        this.sizeStyle = "py-1";
    }

    switch (this.radius) {
      case "large":
        this.RadiusStyle = "rounded-[50px]";
        break;

      case "medium":
        this.RadiusStyle = "rounded-[10px]";
        break;
      case "small":
        this.RadiusStyle = "rounded-[8px]";
        break;
    }

    switch (this.theme) {
      case "positiveOutline":
        this.themeStyle = " border border-estationsGreen-500 bg-white";
        break;
      case "greyOutline":
        this.themeStyle = " border border-gray-300 bg-gray-50";
        break;
      case "yellowOutline":
        this.themeStyle = " border border-yellow-500 ";
        break;
      case "danger":
        this.themeStyle = "bg-[#D44333]";
        break;
      case "dangerLight":
        this.themeStyle = "bg-[#FDF0EF]";
        break;
      case "dangerOutline":
        this.themeStyle = "border border-red-400";
        break;
      case "positiveLight":
        this.themeStyle = "bg-estationsGreen-50";
        break;
      case "positiveOutline":
        this.themeStyle = "border border-green-400";
        break;
      case "positiveSolid":
        this.themeStyle = "bg-estationsGreen-500";
        break;
      case "positiveGhost":
        this.themeStyle = "bg-transparent text-estationsGreen-500";
        break;
      case "blackSolid":
        this.themeStyle = "bg-[#000000] text-white";
        break;
      case "blackPositiveOutline":
        this.themeStyle = "bg-[#000000] border border-estationsGreen-500 ";
      case "blackOutline":
        this.themeStyle = "border border-black text-black";
      case "inactiveGrey":
        this.themeStyle = "border bg-gray-400";
    }
  },

  methods: {
    handleClick() {
      // GA4 CUSTOM BUTTON EVENT TRACKER
      if (this.eventName && window.gtag) {
        window.gtag("event", this.eventName, {
          event_category: this.eventCategory || "button",
          event_label:
            this.eventLabel || this.$slots.default?.[0]?.children || "Button",
        });
      }
      this.$emit("handleClick");
    },
  },
};
</script>

<style></style>
